import * as types from "./actionTypes";
import * as constants from "../constants/DomainConstants";
import aanvraagApi from "../api/aanvraagApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import * as beads from "./beadActions";

// ----------------------------------------------------------------------------
export function aanvraagLoaded(aanvraag, errors) {
	return {
		type: types.AANVRAAG_LOADED,
		body: {
			item: aanvraag,
			errors: errors
		}
	};
}

export function loadAanvraag(dossierId) {
	return (dispatch) => {
		dispatch(ajax.started());

		return aanvraagApi.get(dossierId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(aanvraagLoaded(response.data.item, response.data.validationResults));
				dispatch(beads.beadsLoaded(response.data.item.beadModels));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function loadEmptyAanvraag(typeId) {
	return (dispatch) => {
		dispatch(ajax.started());

		return aanvraagApi.loadEmptyAanvraag(typeId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(aanvraagLoaded(response.data));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function loadEmptyRenovatie() {
	return (dispatch) => {
		dispatch(ajax.started());

		return aanvraagApi.loadEmptyRenovatie()
			.then(response => {
				dispatch(ajax.ended());
				dispatch(aanvraagLoaded(response.data));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function loadAanvraagFromSimulatie(simulatieId) {
	return (dispatch) => {
		dispatch(ajax.started());

		return aanvraagApi.getFromSimulatie(simulatieId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(aanvraagLoaded(response.data));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}


// ----------------------------------------------------------------------------
export function aanvraagSaved(aanvraag, errors) {
	return {
		type: types.AANVRAAG_SAVED,
		body: {
			item: aanvraag,
			errors: errors
		}
	};
}

export function saveAanvraag(aanvraag) {
	return (dispatch) => {
		dispatch(ajax.started());

		return aanvraagApi.save(aanvraag)
			.then((response) => {
				dispatch(ajax.ended());

				if (response.data.concurrencyException) {
					dispatch(aanvraagSaved(response.data.item, response.data.validationResults));
					return constants.HAS_CONCURRENCY_EXCEPTION;
				}

				if (Object.keys(response.data.validationResults).length !== 0) {
					dispatch(aanvraagSaved(response.data.item, response.data.validationResults));
					return constants.HAS_VALIDATION_ERRORS;
				}

				dispatch(aanvraagSaved(response.data.item));
				dispatch(beads.beadsLoaded(response.data.item.beadModels));
				return constants.SUCCESS;
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

// ----------------------------------------------------------------------------
export function aanvraagCleared() {
	return {
		type: types.AANVRAAG_CLEARED
	};
}

export function clearAanvraag() {
	return function (dispatch) {
		dispatch(aanvraagCleared());
	};
}

// ----------------------------------------------------------------------------
//'get' because the result is directly returned to the requestor
//no action is dispatched and reduced, and the result is not pushed to the store. load = load it into the store
export function getEmptyAanvrager() {
	return (dispatch) => {
		dispatch(ajax.started());
		return aanvraagApi.loadEmptyAanvrager()
			.then(response => {
				dispatch(ajax.ended());
				return response.data;
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function getEmptyMandataris(accountId) {
	return (dispatch) => {
		dispatch(ajax.started());
		return aanvraagApi.loadEmptyMandataris(accountId)
			.then(response => {
				dispatch(ajax.ended());
				return response.data;
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}
